import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./ProjectSubtaskSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";

import ProjectSubtaskModalFormStepOne from "./ProjectSubtaskModalFormStep/ProjectSubtaskModalFormStepOne";

import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

const ProjectSubtaskModalForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);
  const [workers, setWorkers] = useState([]);
  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    const workersFetch = GlobalAuthFetch({ path: "/worker/all" });
    const [workersPayload] = await Promise.all([workersFetch]);
    setWorkers(workersPayload?.payload?.data);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, { ...props, initialValues })}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={false}
    >
      {(formProps) => {
        return (
          <>
            <form
              id={props.formName}
              onSubmit={formProps.handleSubmit}
              className="ProjectSubtaskModalForm"
            >
              <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={step}
                onChangeIndex={(index) => setStep(index)}
              >
                <ProjectSubtaskModalFormStepOne
                  {...formProps}
                  {...props}
                  workers={workers}
                />
              </SwipeableViews>
            </form>
          </>
        );
      }}
    </Form>
  );
};

export default ProjectSubtaskModalForm;
